import {ElementClientRect} from '../../models/common/elementClientRect'

export const getElementClientRect = (element: Element): ElementClientRect => {
  const boundingClientRect = element.getBoundingClientRect()

  return {
    x1: boundingClientRect.x,
    x2: boundingClientRect.x + boundingClientRect.width,
    y1: boundingClientRect.y,
    y2: boundingClientRect.y + boundingClientRect.height,
  }
}

export const getElementClientPositionById = (
  id: string,
): ElementClientRect | null => {
  const element = document.getElementById(id)

  if (!element) {
    return null
  }

  return getElementClientRect(element)
}

export const getRectEndValues = (
  origRect: ElementClientRect | null,
  rect: ElementClientRect | null,
): ElementClientRect | null => {
  if (null === origRect) {
    return rect
  }

  if (null === rect) {
    return origRect
  }

  return {
    x1: rect.x1 < origRect.x1 ? rect.x1 : origRect.x1,
    x2: rect.x2 > origRect.x2 ? rect.x2 : origRect.x2,
    y1: rect.y1 < origRect.y1 ? rect.y1 : origRect.y1,
    y2: rect.y2 > origRect.y2 ? rect.y2 : origRect.y2,
  }
}
